import { Button } from 'reakit/Button';
import styled, { css } from 'styled-components';

export const CloseButton = styled(Button)`
  width: 32px;
  height: 32px;
  background: #ffffff;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: none;
  box-shadow: 0px 3px 8px -5px #000;
  ${(props) =>
    props.disabled &&
    css`
      svg path {
        fill: var(--pd-disabled-button-bg-color);
      }
    `}
`;
